import viewMore from '../../components/view-more.vue';
import spaceMixin from '@/modules/space-mixin';
import styleMixin from '@/modules/color-mixin';

export default {
    i18next: {
        ns: 'md-team-desc'
    },
    mixins: [spaceMixin(), styleMixin({ '--g-bg-color': ['descBgColor'] })],
    data: function() {
        return {
            type: '',
            descBgColor: '',
            descBgImg: {
                src: '',
                mobileSrc: ''
            },
            title: '',
            teamImage: '',
            introduction: '',
            performancesColor: '',
            performancesBgType: '',
            performancesBgColor: '',
            performancesBgImg: '',
            performances: [],
            useMask: false,
        };
    },
    components: {
        viewMore
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        useBgSrc() {
            return !this.isMobileSize
                ? this.descBgImg?.src || this.descBgImg?.mobileSrc
                : this.descBgImg?.mobileSrc || this.descBgImg?.src;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
};
